import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { cls } from '@mssgme/helpers';
import styles from './styles.scss';

const Badge = ({ as: Tag = 'span', badgeStyle, inverse, ...rest }) => (
    <Tag {...cls(classNames(styles.root, styles[badgeStyle], inverse && styles.inverse), rest)} />
);

Badge.propTypes = {
    as: PropTypes.elementType,
    badgeStyle: PropTypes.oneOf(['primary', 'danger', 'success', 'warning', 'flat']),
    inverse: PropTypes.bool,
};

export default Badge;
